import { Endereco } from "../pages/Endereco";
import { CertidaoCondutor } from "../pages/habilitacao/CertidaoCondutor";
import { CnhDefinitiva } from "../pages/habilitacao/CnhDefinitiva";
import { ConsultaCNH } from "../pages/habilitacao/ConsultarCNH";
import { EmitirTaxas } from "../pages/habilitacao/EmitirTaxas";
import { PidConfirmation } from "../pages/habilitacao/ProcessoPid/PidConfirmation";
import { PidRequest } from "../pages/habilitacao/ProcessoPid/PidRequest";
import { RenovacaoCnh } from "../pages/habilitacao/RenovacaoCNH";
import { SegundoVia } from "../pages/habilitacao/SegundoVia";
import { Home } from "../pages/Home";
import { ConsultarPontos } from "../pages/infracoes/ConsultarPontos";
import { Login } from "../pages/Login";
import { CertidaoBaixa } from "../pages/veiculos/CertidaoBaixa";
import { CertidaoPropriedade } from "../pages/veiculos/CertidaoPropriedade";
import { ConsultaCRLVe } from "../pages/veiculos/ConsultaCRLVe";
import { ConsultaIpva } from "../pages/veiculos/ConsultaIpva";
import { DebitosVeiculo } from "../pages/veiculos/DebitosVeiculo";
import { InclusaoGravame } from "../pages/veiculos/InclusaoGravame";
import { Infracoes } from "../pages/veiculos/Infracoes";
import { Veiculos } from "../pages/veiculos/Veiculos";
export var AppRoutes = {
    "/": Login,
    "/home/:search?/:category?": Home,
    "/veiculos/:servico": Veiculos,
    "/veiculos/consulta-licenciamentos/:placa": DebitosVeiculo,
    "/veiculos/consulta-ipva/:placa": ConsultaIpva,
    "/veiculos/consulta-crlve/:placa": ConsultaCRLVe,
    "/veiculos/certidao-baixa/:placa": CertidaoBaixa,
    "/veiculos/certidao-propriedade/:placa": CertidaoPropriedade,
    "/veiculos/infracoes/:placa": Infracoes,
    "/veiculos/inclusao-gravame/:placa": InclusaoGravame,
    "/habilitacao/consulta-cnh": ConsultaCNH,
    "/habilitacao/renovacao-cnh": RenovacaoCnh,
    "/habilitacao/emitir-taxas": EmitirTaxas,
    "/habilitacao/cnh-definitiva": CnhDefinitiva,
    "/habilitacao/segundo-via": SegundoVia,
    "/habilitacao/processo-pid": PidRequest,
    "/habilitacao/resumo-processo-pid": PidConfirmation,
    "/habilitacao/certidao-condutor": CertidaoCondutor,
    "/infracoes/consulta-pontos": ConsultarPontos,
    "/alterar-endereco": Endereco,
};
